import { Component, Input } from '@angular/core';

@Component({
    selector: 'fcp-badge',
    templateUrl: './fcp-badge.component.html',
    styleUrls: ['./fcp-badge.component.less'],
    standalone: false
})
export class FcpBadgeComponent {
    @Input() text: string;
    @Input() color: FcpBadgeColor = FcpBadgeColor.Neutral;
    @Input() size: FcpBadgeSize = FcpBadgeSize.Small;
    @Input() inversed = false;

    public get isInversed() {
        return this.inversed;
    }
}

export enum FcpBadgeColor {
    Promotion = 'promotion',
    Neutral = 'neutral',
    Success = 'success',
    Informative = 'informative',
    Primary = 'primary',
    Warning = 'warning',
    Crititcal = 'critical'
}

export enum FcpBadgeSize {
    Small = 'small',
    Medium = 'medium',
    Big = 'big',
    SmallRound = 's-round'
}
